import React from 'react'

const Manual_menu_subcategorias = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          MENÚ - Subcategorías
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo crear o editar subcategorías en un menú, detallando pasos como nombrarlas, asignarlas a una categoría principal y especificar impuestos. Ayuda a mejorar la organización y eficiencia operativa.
        </p>
        <iframe
          src="https://scribehow.com/embed/MENU__Subcategorias__7u7tPG1YR-edDJDBbNuzLg?as=scrollable"
          className="scribe-iframe-general-18"
          width="100%"
          height="4100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_menu_subcategorias
